import ClassNames from "./classNames.js";

/**
 * Central store for selecting dom elements
 */

/**
 * Basic layout
 */

// Optional root element wrapper for platform specific configuration
// See example: ./front-end/src/index-local-dev.hbs
const $configWrapper = document.getElementById("shared-header-config-wrapper");

// HTML document body
const $htmlBody = document.querySelector(`body`);

const $logo = document.querySelector(`.${ClassNames.layout.logo}`);

// Mobile menu button
const $menuButtonMobile = document.querySelector(
  `.${ClassNames.layout.menuButtonMobile}`
);

// Nav container
const $navContainer = document.querySelector(
  `.${ClassNames.layout.navContainer}`
);

// Nav container wrapper
const $navContainerWrapper = document.querySelector(
  `.${ClassNames.layout.navContainerWrapper}`
);

// Black opacity backdrop
const $overlay = document.querySelector(`.${ClassNames.overlay}`);

// Root Element
// Please note; an addtional wrapper is optional per platform to set up platform specific configuration
// See example: ./front-end/src/index-local-dev.hbs
const $rootElement = document.querySelector(
  `.${ClassNames.layout.rootElement}`
);

/**
 * Nav primary
 */

// Nav primary container
const $navPrimaryContainer = document.querySelector(
  `.${ClassNames.navPrimary.container}`
);

// Nav primary links
const $navPrimaryLinks = Array.prototype.slice.call(
  document
    .querySelector(`.${ClassNames.layout.navContainer}`)
    ?.querySelectorAll("a") || []
);

// Nav primary main nav items (level 1 items)
const $navPrimaryMainItems = Array.prototype.slice.call(
  document.querySelectorAll(`.${ClassNames.navPrimary.mainItem}`) || []
);

// Nav primary buttons controlling a submenu
const $navPrimarySubmenuButtons = Array.prototype.slice.call(
  document
    .querySelector(`.${ClassNames.layout.navContainer}`)
    ?.querySelectorAll(`button.${ClassNames.navPrimary.mainItem}`) || []
);

// Nav primary subnavigation group of links
const $navPrimarySubNavGroups = Array.prototype.slice.call(
  document.querySelectorAll(`.${ClassNames.navPrimary.subNavGroup}`) || []
);

// Nav primary sub navigations
const $navPrimarySubNavs = Array.prototype.slice.call(
  document.querySelectorAll(`.${ClassNames.navPrimary.subNav}`) || []
);

/**
 * Nav domain
 */

// Nav domain container
const $navDomain = document.querySelector(`.${ClassNames.navDomain.nav}`);

// Nav domain links
const $navDomainLinks = $navDomain
  ? Array.prototype.slice.call($navDomain.querySelectorAll("a") || [])
  : [];

/**
 * Search
 */

// Search mobile toggle button
const $searchButtonToggleSearchMobile = document.querySelector(
  `.${ClassNames.search.buttonToggleSearchMobile}`
);

// Search form wrapper mobile
const $searchFormWrapperMobile = document.querySelector(
  `.${ClassNames.search.formWrapperMobile}`
);

// Search form mobile
const $searchFormMobile = document
  .querySelector(`.${ClassNames.search.dialog}`)
  ?.querySelector(`.${ClassNames.search.form}`);

// Search form wrapper desktop
const $searchFormDesktop = $navContainerWrapper?.querySelector(
  `.${ClassNames.search.form}`
);

// Search form input mobile
const $searchInputMobile = $searchFormMobile
  ? $searchFormMobile.querySelector("input")
  : null;

// Search form input desktop
const $searchInputDesktop = $searchFormDesktop
  ? $searchFormDesktop.querySelector("input")
  : null;

// Search button clear mobile
const $searchBtnClearMobile = $searchFormMobile
  ? $searchFormMobile.querySelector(`.${ClassNames.search.buttonClear}`)
  : null;

// Search button clear desktop
const $searchBtnClearDesktop = $searchFormDesktop
  ? $searchFormDesktop.querySelector(`.${ClassNames.search.buttonClear}`)
  : null;

// Search button submit mobile
const $searchSubmitMobile = $searchFormMobile
  ? $searchFormMobile.querySelector(`.${ClassNames.search.buttonSubmit}`)
  : null;

// Search button submit desktop
const $searchSubmitDesktop = $searchFormDesktop
  ? $searchFormDesktop.querySelector(`.${ClassNames.search.buttonSubmit}`)
  : null;

// Search button auto complete mobile
const $searchAutoCompleteMobile = $searchFormMobile
  ? $searchFormMobile.querySelector(`.${ClassNames.search.autoComplete}`)
  : null;

// Search button auto complete desktop
const $searchAutoCompleteDesktop = $searchFormDesktop
  ? $searchFormDesktop.querySelector(`.${ClassNames.search.autoComplete}`)
  : null;

export default {
  $configWrapper,
  $htmlBody,
  $logo,
  $menuButtonMobile,
  $navContainer,
  $navContainerWrapper,
  $overlay,
  $rootElement,
  $navPrimaryContainer,
  $navPrimaryLinks,
  $navPrimaryMainItems,
  $navPrimarySubmenuButtons,
  $navPrimarySubNavGroups,
  $navPrimarySubNavs,
  $navDomain,
  $navDomainLinks,
  $searchButtonToggleSearchMobile,
  $searchFormWrapperMobile,
  $searchFormMobile,
  $searchFormDesktop,
  $searchInputMobile,
  $searchInputDesktop,
  $searchBtnClearMobile,
  $searchBtnClearDesktop,
  $searchSubmitMobile,
  $searchSubmitDesktop,
  $searchAutoCompleteMobile,
  $searchAutoCompleteDesktop,
};
